import {useAuth} from "../stores/AuthStore";
import {storeToRefs} from "pinia";

export const completedProfileGuard = (to, from, next) => {
    const {profileStatus} = storeToRefs(useAuth());

    if (profileStatus.value !== null && profileStatus.value === 'profile_complete') {
        return next();
    }

    return next('/complete-profile-reminder');
};
